<bpw-menu [showBackButton]="false" [showSessionId]="true" [showSettings]="true"></bpw-menu>

@if (!loadSettingsFailed()) {
  <div class="row mx-2">
    @if (adressDashboardCardData(); as adCard) {
      @if (adCard.visible) {
        <div class="col-lg-4 col-md-6 col-xs-12 mt-2 p-1">
          <bpw-ad-dashboardcard [data]="adCard.data"></bpw-ad-dashboardcard>
        </div>
      }
    }

    @if (projektDashboardCardData(); as projektCard) {
      @if (projektCard.visible) {
        <div class="col-lg-4 col-md-6 col-xs-12 mt-2 p-1">
          <bpw-pr-dashboardcard [data]="projektCard.data"></bpw-pr-dashboardcard>
        </div>
      }
    }

    @if (urpDashboardCardData(); as urpCard) {
      @if (urpCard.visible) {
        <div class="col-lg-4 col-md-6 col-xs-12 mt-2 p-1">
          <bpw-urp-dashboardcard [data]="urpCard.data"></bpw-urp-dashboardcard>
        </div>
      }
    }

    @if (arpDashboardCardData(); as arpCard) {
      @if (arpCard.visible) {
        <div class="col-lg-4 col-md-6 col-xs-12 mt-2 p-1">
          <bpw-arp-dashboardcard [data]="arpCard.data"></bpw-arp-dashboardcard>
        </div>
      }
    }

    @if (bjDashboardCardData(); as bjCard) {
      @if (bjCard.visible) {
        <div class="col-lg-4 col-md-6 col-xs-12 mt-2 p-1">
          <bpw-bj-dashboardcard [data]="bjCard.data"></bpw-bj-dashboardcard>
        </div>
      }
    }

    @if (qrDashboardCardData(); as qrCard) {
      @if (qrCard.visible) {
        <div class="col-lg-4 col-md-6 col-xs-12 mt-2 p-1">
          <bpw-qr-dashboardcard></bpw-qr-dashboardcard>
        </div>
      }
    }
  </div>
}

@if (loadComplete() && loadSettingsFailed()) {
  <div class="row text-center text-danger pt-5">
    <div class="col">Das Laden der Einstellungen ist fehlgeschlagen, bitte Seite neu laden</div>
  </div>
}

@if (!loadComplete()) {
  <div id="status">
    <div class="text-center pt-3">
      <bpw-loader></bpw-loader>
    </div>
  </div>
}

@if (loadComplete() && !refreshComplete()) {
  <div id="status">
    <div class="text-center pt-3">
      <bpw-loader-refresh></bpw-loader-refresh>
    </div>
  </div>
}
